<template>
  <div class="flex h-full w-full flex-col gap-5">
    <div
      v-if="usersForFilter.length > 1 || eventsForFilter.length > 1"
      class="flex shrink-0 flex-col gap-3 md:flex-row"
    >
      <div v-if="usersForFilter.length > 1" class="md:w-2/5">
        <SelectComponent
          v-model="filter.users"
          :values="usersForFilter"
          :label="$t('attributes.users')"
          name="users"
          multiple
        />
      </div>
      <div v-if="eventsForFilter.length > 1" class="md:w-2/5">
        <SelectComponent
          v-model="filter.descriptions"
          :values="eventsForFilter"
          :label="$t('global.events')"
          name="descriptions"
          multiple
        />
      </div>
    </div>
    <div v-if="filteredActivities.length" class="flex flex-col gap-3">
      <ActivityBlock
        v-for="activity in filteredActivities"
        :key="activity.id"
        :activity="activity"
      />
    </div>
    <div
      v-else
      class="flex flex-1 items-center justify-center py-10 font-semibold text-gray-500"
    >
      {{ $t('global.no_activity') }}
    </div>
  </div>
</template>

<script>
import SelectComponent from '@c/BaseFormComponent/SelectComponent.vue'
import ActivityBlock from './ActivityBlock.vue'

/**
 * An activity log, as FM's ActivityContainer: filters on the author and the
 * event (when there is a choice), most recent first.
 */
export default {
  name: 'ActivityTable',
  components: { ActivityBlock, SelectComponent },
  props: {
    activities: { type: [Array, Object], required: false, default: () => [] }
  },
  data() {
    return { filter: { users: [], descriptions: [] } }
  },
  computed: {
    list() {
      const list = Array.isArray(this.activities)
        ? this.activities
        : Object.values(this.activities ?? {})
      return [...list].sort((a, b) => b.created_at.localeCompare(a.created_at))
    },
    filteredActivities() {
      return this.list.filter(
        (activity) =>
          (!this.filter.users?.length ||
            this.filter.users.includes(activity.causer_id ?? 0)) &&
          (!this.filter.descriptions?.length ||
            this.filter.descriptions.includes(activity.description))
      )
    },
    usersForFilter() {
      const users = new Map()
      this.list.forEach((activity) =>
        users.set(
          activity.causer_id ?? 0,
          activity.causer?.full_name ?? this.$t('global.system')
        )
      )
      return [...users].map(([id, name]) => ({ id, name }))
    },
    eventsForFilter() {
      return [
        ...new Set(this.list.map((activity) => activity.description))
      ].map((description) => ({
        id: description,
        name: this.$t(`enums.activityLog.type.${description}`)
      }))
    }
  }
}
</script>
